import color from "@constants/color";
import { ActivityIndicator, View } from "react-native";
import React from "react";

const Loading = ({ isLoading }) =>
  isLoading ? (
    <View
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ActivityIndicator size="large" color={color.primary} />
    </View>
  ) : null;

export default Loading;
